import React from "react";
import Navbar from "../GeneralComponents/Navbar";
import SideNav from "../GeneralComponents/SideNav";
import { ReactComponent as Bubbles } from "./ForgotPasswordSvg.svg";

function ForgotPasswordSuccess({ handleClick }) {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-4">
      <SideNav className="!static hidden md:block" />
      <div className="col-span-1 lg:col-span-3">
        <Navbar />
        <div className="bg-[#F3F5F9] flex flex-col items-center md:mt-4 lg:mt-4 border h-screen lg:h-[500px] rounded-3xl lg:pb-16 lg:w-[400px] lg:mx-auto lg:scale-[80%]">
          <Bubbles />
          <button
            onClick={handleClick}
            className="py-3 mt-[-4rem] px-[60px] bg-pw-blue text-white rounded-3xl hover:bg-cyan-500"
          >
            Retry
          </button>
        </div>
      </div>
    </div>
  );
}

export default ForgotPasswordSuccess;
